export const STATUS = {
  isPlaying: 'playing',
  isPaused: 'paused',
};
